import styled from "styled-components";

export const StyledBookingConfirmation = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  padding: 20px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 5% 15%;

    min-height: initial;
  }
  .go-back {
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }
  h1 {
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text};
  }
  h2 {
    font-size: 16px;
    font-weight: 600;
    margin: 0px;
    color: ${({ theme }) => theme.colors.text};
  }
  h4 {
    color: ${({ theme }) => theme.colors.text};
  }
  p {
    margin: 0px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.text};
  }
  strong {
    color: ${({ theme }) => theme.colors.text};
  }
  .coupon-btn {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    font-weight: 600;
    border-radius: 0px 4px 4px 0;
  }
`;

export const StyledUnitImage = styled.img`
  height: 80px;
  width: 80px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
`;
export const EditButton = styled.p`
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  font-weight: 600;
`;

export const StyledCoupon = styled.input`
  height: 44px;
  flex: 1;
`;
